import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-78cab666"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "tab-bar-light van-safe-area-bottom"
};
const _hoisted_2 = {
  class: "wrap"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("店铺主页");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("店铺信息");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("会员中心");

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "zw van-safe-area-bottom"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
    class: "item",
    to: "/"
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _createVNode(_component_router_link, {
    class: "item",
    to: "/store-detail"
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  }), _createVNode(_component_router_link, {
    class: "item",
    to: "/my"
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  })]), _renderSlot(_ctx.$slots, "bottom", {}, undefined, true)]), _hoisted_6], 64);
}